import {Component} from '@angular/core';
import {UserStatisticsFilesComponent} from '../user-statistics-files/user-statistics-files.component';

@Component({
    selector: 'app-pure-originals-stats',
    standalone: true,
    imports: [UserStatisticsFilesComponent],
    templateUrl: './pure-originals-stats.component.html',
    styleUrl: './pure-originals-stats.component.css'
})
export class PureOriginalsStatsComponent {}
